import React, { useEffect, useState } from "react";
import Header from "components/user/Header";
import banner from "assets/img/banner.png";
import CardKontakSekolah from "components/user/profile/kontak-sekolah/CardKontakSekolah";
import Footer from "components/user/Footer";
import BeritaPopuler from "components/user/BeritaPopuler";
import axios from "axios";

function KontakSekolah() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-grow">
        <div className="row mt-[75px] flex flex-wrap gap-6 p-5">
          <div className="w-full lg:w-[68%]">
            <CardKontakSekolah />
          </div>
          <div className="w-full lg:ml-auto lg:w-[30%]">
            <BeritaPopuler />
          </div>
        </div>
      </main>

       <Footer className="mt-auto" />
    </div>
  );
}
export default KontakSekolah;
